import { Theme } from "theme-ui";
import { border } from "./util";

export const cards: Theme["cards"] = {
  primary: {
    boxShadow: "none",
    backgroundColor: "surface.default",
    borderRadius: "12px",
    padding: 5,
    ...border({ borderColor: "borders.subtle" }),
    display: "inline-flex"
  },
  compact: {
    variant: "cards.primary",
    border: "none",
    borderRadius: 0,
    padding: 2,
    paddingRight: 3
  },
  elevated: {
    variant: "cards.compact",
    backgroundColor: "surface.highlight",
    margin: 2,
    boxShadow: 3,
    padding: 4,
    paddingRight: 4
  },
  form: {
    variant: "cards.primary",
    border: "none",
    padding: [3, 4]
  },
  tooltip: {
    variant: "cards.compact",
    backgroundColor: "surface.dark",
    padding: 2,
    border: "none",
    borderRadius: 0,
    textAlign: "center",
    label: "tooltip",
    paddingRight: 2
  },
  ["tooltip-light"]: {
    variant: "cards.tooltip",
    backgroundColor: "surface.highlight",
    label: "tooltip-light",
    boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.16);"
  },
  ["tooltip-tiny"]: {
    variant: "cards.tooltip",
    backgroundColor: "#ECECFB",
    label: "tooltip-tiny",
    padding: 1,
    paddingRight: 2,
    paddingLeft: 2,
    borderRadius: "8px"
  },
  listItem: {
    variant: "cards.primary",
    padding: 2,
    paddingRight: 3,
    backgroundColor: "transparent",
    ...border({
      borderColor: "borders.muted",
      borderStyle: "solid",
      borderWidth: "1px"
    })
  },
  search: {
    variant: "cards.primary",
    padding: 2,
    backgroundColor: "transparent",
    cursor: "pointer",
    border: "none",
    transition: "all 0.1s ease-in-out",
    ":hover": {
      backgroundColor: "background.subtle"
    },
    ":focus": {
      outlineColor: "focus.default",
      outlineWidth: "2px",
      outlineStyle: "solid"
    }
  },
  cover: {
    variant: "cards.primary",
    backgroundColor: "surface.highlight",
    borderColor: "borders.subtle",
    borderWidth: "2px",
    margin: 2,
    boxShadow: "unset",
    padding: 5,
    paddingRight: 5
  },
  section: {
    variant: "cards.primary",
    backgroundColor: "surface.highlight",
    borderColor: "borders.subtle",
    borderWidth: "1px",
    margin: 2,
    boxShadow: "unset",
    padding: 5
  }
};
